import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_CALCULATION_FETCH_EARNING_PERCENT_OPTIONS_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
